import ApiService from "@/core/services/api.service";
// action types
export const ACCOUNT_VALIDATE = "accountValidate";
export const ACCOUNT_CREATE = "accountCreate";
// mutation types
export const SET_ERROR = "setError";

//const url = 'https://apifacturacionbot.contemporaseguros.com/facturacioncomisionapi'
//const url = 'https://localhost:44340'

const state = {
  errors: null,
};

const actions = {
  [ACCOUNT_VALIDATE](context, account) {
    return new Promise(resolve => {
      ApiService.post({action:`/facturacioncomisionapi/api/Usuario/v1/usuario/validar`}, account)
        .then(({ data }) => {
          ////console.log(('retorna ' + data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log((response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [ACCOUNT_CREATE](context, account) {
    return new Promise(resolve => {
      ApiService.post({action:`/facturacioncomisionapi/api/Usuario/v1/registro/`}, account)
        .then(({ data }) => {
          //console.log(('retorna ' + data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log((response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
}

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  }
};

export default {
  state,
  actions,
  mutations
};
